import { render } from "./Journey.vue?vue&type=template&id=4463f2f2&scoped=true"
import script from "./Journey.vue?vue&type=script&lang=js"
export * from "./Journey.vue?vue&type=script&lang=js"

import "./Journey.vue?vue&type=style&index=0&id=4463f2f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4463f2f2"]])

export default __exports__